import {
  ChipBadge,
  deserify,
  FilterSortPopup,
  firstLetterImage,
  getLocalStorage,
  getMediaBasePath,
  ImageWrapper,
  IStyles,
  MultiSelect,
  PrimaryButton,
  pxToRem,
  pxTovW,
  SearchBar,
  theme,
  useCommonServiceClientContext,
} from '@geneo2-web/shared-ui';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import {
  Checkbox,
  Divider,
  Grid,
  Modal,
  Tooltip,
  Typography,
  useMediaQuery,
} from '@mui/material';
import { Box } from '@mui/system';
import {
  SectionStudent,
  SectionStudentInfo,
} from '@protos/learning_management/lms.assessment.teacher.apis_pb';
import { useAppSelector } from 'apps/teacher/src/reduxStore/reduxHooks';
import { useCallback, useEffect, useState } from 'react';
const styles: IStyles = {
  modal: {
    boxSizing: 'border-box',
    display: { xs: 'flex' },
    alignItems: 'flex-end',
    // top: { xs: '100vh', md: '-30%', lg: '0' },
    flexDirection: { xs: 'column' },
    gap: { md: pxToRem(20) },
    width: { xs: 'unset', md: 'max-content' },
    height: 'max-content',
    margin: { md: 'auto' },
    marginTop: { xs: 'auto' },
  },

  root: {
    backgroundColor: 'common.white',
    // backgroundColor: 'yellow',
    // overflow: 'hidden',
    // overflowY: 'scroll',
    margin: { md: 'auto' },
    width: { xs: '100vw', md: pxToRem(500), lg: pxTovW(971) },
    // height: { xs: pxToRem(364), md: pxToRem(360), lg: pxTovW(528) },
    // maxHeight: { md: pxTovW(528) },
    borderRadius: { xs: `${pxToRem(30)} ${pxToRem(30)} 0 0`, md: pxToRem(15) },
    padding: {
      xs: `${pxToRem(10)} ${pxToRem(10)} `,
      md: `${pxTovW(20)}  ${pxTovW(20)}`,
    },
    boxSizing: 'border-box',
    outline: 'none',
    // mt: { md: '30vh' },
    '&::-webkit-scrollbar': {
      display: 'none',
    },
  },
  headingBox: {
    width: '100%',
    height: 'max-content',
    position: 'sticky',
    borderBottom: '1px solid #E0DFDE',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    boxSizing: 'border-box',
    // gap: { xs: pxToRem(15) },
    padding: {
      xs: `${pxToRem(8)} ${pxToRem(4)}`,
      md: `${pxToRem(0)} ${pxToRem(8)} ${pxToRem(12)} ${pxToRem(8)}`,
    },
    // backgroundColor: 'red',
  },
  cardBox: {
    width: { xs: '100%', md: '90%', lg: '100%' },
    // borderBottom: '1px solid #E0DFDE',

    display: 'flex',
    justifyContent: 'space-between',
    padding: {
      xs: `${pxToRem(18)} ${pxToRem(0)}`,
      md: `${pxToRem(16)} ${pxToRem(8)}`,
    },
    // backgroundColor: 'red',
  },
  contentBox: {
    width: '100%',
    height: '85%',
    overflowY: 'scroll',
    overflowX: 'hidden',
    '&::-webkit-scrollbar': {
      display: 'none',
    },
    boxSizing: 'border-box',
    // backgroundColor: 'blue',
  },
  //   closeBox: {
  //     display: 'flex',
  //     flexDirection: 'column',
  //     justifyContent: 'center',
  //   },
  close: {
    width: { xs: pxToRem(13) },
    height: { xs: pxToRem(13) },
    alignItems: 'center',
    cursor: 'pointer',
    marginRight: { xs: pxToRem(24), md: pxTovW(19) },
    marginTop: { xs: pxToRem(10), md: pxTovW(10) },
  },
};
interface IDataList {
  name: string;
  id: bigint;
  selected: boolean;
}
interface IProps {
  open: boolean;
  handleClose: () => void;
  sectionList: IDataList[];
  setSectionList: React.Dispatch<React.SetStateAction<IDataList[]>>;
  handleSectionChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  sectionStudentInfo: SectionStudent[];
  setSectionStudentInfo: React.Dispatch<React.SetStateAction<SectionStudent[]>>;
  // Source of truth for which class/subject students should be fetched from.
  // When not provided, component falls back to `class_subject_info` from redux.
  classId?: number;
  subjectId?: number;
  assessmentId?: bigint;
  useAttendanceApi?: boolean;
  onCloseAction?: (props: {
    selectedStudents: SectionStudent[];
    allStudents: SectionStudentInfo[];
  }) => void | Promise<void>;
  onSubmitAction?: (props: {
    selectedStudents: SectionStudent[];
    allStudents: SectionStudentInfo[];
  }) => void | Promise<void>;
}
export const StudentListPopup = (props: IProps) => {
  const {
    open,
    handleClose,
    sectionList,
    setSectionList,
    handleSectionChange,
    sectionStudentInfo,
    setSectionStudentInfo,
    classId,
    subjectId,
    assessmentId,
    useAttendanceApi = false,
    onCloseAction,
    onSubmitAction,
  } = props;
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [sectionStudentList, setSectionStudentList] = useState<
    SectionStudentInfo[]
  >([]);
  const [selectedStudentList, setSelectedStudentList] =
    useState<SectionStudent[]>(sectionStudentInfo);
  const isIpad = useMediaQuery(theme.breakpoints.down('lg'));
  const isIpadOnly = !isMobile && isIpad;
  const {
    LmsAssessmentTeacherAPIServiceV2WithStatusCodeHandler,
    LmsAssessmentTeacherAPIServiceV1WithStatusCodeHandler,
  } = useCommonServiceClientContext();

  const [sortBy, setSortBy] = useState<'Name' | undefined>(undefined);
  const [searchText, setSearchText] = useState('');
  const teacher_id = getLocalStorage('userId');
  const { class_subject_info } = deserify(
    useAppSelector((state) => state.homeDashboard)
  );
  const fetchClassId = classId ?? class_subject_info?.classId;
  const fetchSubjectId = subjectId ?? class_subject_info?.subjectId;
  const selectedSectionListIds = sectionList
    .filter((val) => val.selected)
    .map((val) => val.id)
    .sort();

  let filteredStudentList = [...sectionStudentList].filter((val) =>
    selectedSectionListIds.includes(val.sectionId)
  );

  filteredStudentList.sort((a, b) => {
    // First, sort by sectionId
    if (a.sectionId < b.sectionId) return -1;
    if (a.sectionId > b.sectionId) return 1;
    // Now, sort by rollNumber
    const aIsNum = !isNaN(Number(a.rollNumber));
    const bIsNum = !isNaN(Number(b.rollNumber));
    if (aIsNum && bIsNum) {
      return Number(a.rollNumber) - Number(b.rollNumber);
    } else {
      // Both are not numbers, compare as strings
      if (a.name < b.name) return -1;
      if (a.name > b.name) return 1;
      return 0;
    }
  });

  if (searchText) {
    filteredStudentList = filteredStudentList.filter(
      (val) =>
        val.name.toLowerCase().includes(searchText.toLowerCase()) ||
        val.rollNumber.toLowerCase().includes(searchText.toLowerCase()) ||
        val.classId.toString().toLowerCase().includes(searchText.toLowerCase())
    );
  }

  if (sortBy === 'Name') {
    filteredStudentList = filteredStudentList.sort((a, b) => {
      return a.name.localeCompare(b.name);
    });
  }

  const handleSortBy = (val: string) => {
    if (val === 'Name') {
      if (sortBy === 'Name') {
        setSortBy(undefined);
      } else {
        setSortBy('Name');
      }
    }
  };

  const fetchStudentsList = async () => {
    try {
      if (fetchClassId == null || fetchSubjectId == null) return;
      const response =
        await LmsAssessmentTeacherAPIServiceV1WithStatusCodeHandler.fetchSectionStudents(
          {
            personId: BigInt(teacher_id),
            classId: fetchClassId,
            sectionIds: sectionList.map((val) => Number(val.id)),
            subjectId: fetchSubjectId,
          }
        );
      setSectionStudentList(response.sectionStudentsInfo || []);
    } catch (error) {
      console.log(error);
    }
  };

  const fetchAttendanceList = useCallback(async () => {
    try {
      if (!assessmentId) return;
      const response =
        await LmsAssessmentTeacherAPIServiceV2WithStatusCodeHandler.getAttendance(
          {
            teacherId: BigInt(teacher_id),
            assessmentId,
          }
        );

      const students = response?.data?.students ?? [];
      const sectionNameById = new Map(sectionList.map((s) => [s.id, s.name]));

      setSectionStudentList(
        students.map(
          (student: any) =>
            new SectionStudentInfo({
              studentId: student.studentId,
              name: student.studentName ?? '',
              sectionId: student.sectionId ?? 0,
              sectionName: student.sectionName ?? '',
              rollNumber: student.rollNumber ?? '',
              classId: student.classId ?? 0,
              class: student.class ?? '',
              profilePicUrl: '',
            })
        )
      );

      setSelectedStudentList(
        students
          .filter((student: any) => student.isPresent)
          .map(
            (student: any) =>
              new SectionStudent({
                sectionId: student.sectionId ?? 0,
                studentId: student.studentId,
              })
          )
      );
    } catch (error) {
      console.log(error);
    }
  }, [
    LmsAssessmentTeacherAPIServiceV2WithStatusCodeHandler,
    assessmentId,
    teacher_id,
    sectionList,
    fetchClassId,
    class_subject_info?.classname,
  ]);
  const addSectionStudent = (prop: SectionStudent) => {
    const { sectionId, studentId } = prop;
    const newSectionStudent: SectionStudent = new SectionStudent({
      sectionId: sectionId,
      studentId: studentId,
    });
    setSelectedStudentList([...selectedStudentList, newSectionStudent]);
  };

  const removeSectionStudent = (prop: SectionStudent) => {
    const { studentId } = prop;
    const newSectionStudentList = selectedStudentList.filter(
      (val) => val.studentId !== studentId
    );
    setSelectedStudentList(newSectionStudentList);
  };

  const selectAllStudents = (checked: boolean) => {
    const newSelectedStudentList = filteredStudentList.map(
      (val) =>
        new SectionStudent({
          sectionId: val.sectionId,
          studentId: val.studentId,
        })
    );
    const oldSelectedStudentList = [...selectedStudentList].filter(
      (val) =>
        !newSelectedStudentList.some((val2) => val2.studentId === val.studentId)
    );
    setSelectedStudentList([
      ...oldSelectedStudentList,
      ...(checked ? newSelectedStudentList : []),
    ]);
  };

  useEffect(() => {
    const updatedSelectedStudentList = [...selectedStudentList].filter((val) =>
      selectedSectionListIds.includes(val.sectionId)
    );
    setSelectedStudentList(updatedSelectedStudentList);
  }, [selectedSectionListIds.join(',')]);

  useEffect(() => {
    if (useAttendanceApi) return;
    fetchStudentsList();
  }, [
    sectionList
      .map((val) => val.id)
      .sort()
      .join(','),
    fetchClassId,
    fetchSubjectId,
    useAttendanceApi,
  ]);

  const onClose = async () => {
    await onCloseAction?.({
      selectedStudents: selectedStudentList,
      allStudents: sectionStudentList,
    });
    setSelectedStudentList(sectionStudentInfo);
    handleClose();
  };

  return (
    <Modal open={open} onClose={onClose} sx={styles.modal}>
      <Box sx={styles.root}>
        <AttendanceRosterFetcher
          enabled={useAttendanceApi}
          assessmentId={assessmentId}
          fetchAttendanceList={fetchAttendanceList}
        />
        <Box sx={styles.headingBox}>
          <Box
            sx={{
              flexGrow: 1,
              display: 'flex',
              alignItems: 'center',
              gap: pxToRem(10),
            }}
          >
            <Typography variant="h3" fontWeight="bold">
              Student List
            </Typography>
            <ChipBadge
              label={filteredStudentList.length}
              color="primary"
              size="small"
            />
          </Box>
          <PrimaryButton
            onClick={async () => {
              await onSubmitAction?.({
                selectedStudents: selectedStudentList,
                allStudents: sectionStudentList,
              });
              setSectionStudentInfo(selectedStudentList);
              handleClose();
            }}
            sx={{
              width: { xs: 'unset', md: pxTovW(153) },
              height: { xs: pxToRem(36), md: pxTovW(58) },
            }}
            // disabled={selectedStudentList.length === 0}
          >
            <Typography variant="h4" color="white" fontWeight="bold">
              CONFIRM
            </Typography>
          </PrimaryButton>
        </Box>
        <Grid container spacing={2} sx={{ marginTop: pxToRem(10) }}>
          <Grid item xs={6} md={6} lg={3}>
            <Box
              sx={{
                border: '1px solid #007CDC',
                borderRadius: pxToRem(10),
                px: pxToRem(10),
                display: 'flex',
                alignItems: 'center',
                // justifyContent: 'center',
                gap: pxToRem(10),
                height: '100%',
              }}
            >
              <Checkbox
                checked={
                  filteredStudentList
                    .map((val) => val.studentId)
                    .every((val) =>
                      selectedStudentList.some((val2) => val2.studentId === val)
                    ) && selectedStudentList.length > 0
                }
                onChange={(event) => {
                  selectAllStudents(event.target.checked);
                }}
                sx={{
                  color: '#007CDC',
                  fontSize: { xs: pxToRem(14), md: pxTovW(21) },
                }}
              />
              <Typography variant="h5">Select All</Typography>
            </Box>
          </Grid>
          <Grid item xs={6} md={6} lg={4}>
            <Box sx={{ height: '100%', display: 'flex', alignItems: 'center' }}>
              <SearchBar
                searchText={searchText}
                handleSearchTextChange={setSearchText}
                handleSearch={() => console.log('search')}
                handleClose={() => {
                  setSearchText('');
                }}
                rootSx={{
                  width: '100%',
                  '& .MuiInputBase-root': {
                    border: '1px solid #007CDC',
                  },
                }}
              />
            </Box>
          </Grid>

          <Grid item xs={6} md={6} lg={3}>
            <Box sx={{ height: '100%', display: 'flex', alignItems: 'center' }}>
              <Box sx={{ flex: 1 }}>
                <MultiSelect
                  selectAllTitle="All Divisions"
                  inputName="homeworkSection"
                  handleChange={(e) => {
                    handleSectionChange(e);
                    console.log(e);
                  }}
                  dataList={sectionList}
                  setDataList={setSectionList}
                  selectSx={{
                    height: 'unset',
                    '& .MuiSelect-select': {
                      py: pxToRem(10),
                    },
                    border: '1px solid #007CDC',
                  }}
                />
              </Box>
            </Box>
          </Grid>
          <Grid item xs={6} md={6} lg={2}>
            <Box
              sx={{
                height: '100%',
                display: 'flex',
                alignItems: 'center',
                // justifyContent: 'flex-end',
                '& div': {
                  width: '100%',
                  '& button': {
                    width: '100%',
                    height: '100%',
                  },
                },
              }}
            >
              <FilterSortPopup
                iconName="Sort"
                options={['Name']}
                title="Sort By"
                sortFunction={(val) => handleSortBy(val)}
              />
            </Box>
          </Grid>
        </Grid>
        <Box
          sx={{
            display: 'flex',
            width: '100%',
            mt: { xs: pxToRem(10), md: pxTovW(20) },
            maxHeight: { xs: '40vh', md: '60vh' },
            overflowY: 'auto',
            overflowX: 'hidden',
          }}
        >
          <Grid
            container
            spacing={0}
            sx={{
              display: 'grid',
              width: '100%',
              boxSizing: 'border-box',
              height: '100%',
              overflowY: 'auto',
              overflowX: 'hidden',
              gridTemplateColumns: { xs: 'auto', md: 'auto auto' }, // 2 columns on md+
              // backgroundColor: '#707070',
              columnGap: 0,
              rowGap: '1px',
            }}
            columnGap={0}
            columnSpacing={0}
          >
            {filteredStudentList.map((e, index) => (
              <Grid
                item
                key={index}
                zeroMinWidth
                sx={{
                  backgroundColor: 'white',
                  p: 0,
                  m: 0,
                  minWidth: 0,
                  width: '100%', // Ensure full width of grid cell
                }}
              >
                <Box
                  sx={{
                    width: '100%',
                    height: '100%',
                    backgroundColor: 'white',
                  }}
                >
                  <StudentCard
                    studentName={e.name}
                    className={e.class}
                    section={e.sectionName}
                    rollNo={e.rollNumber}
                    image={
                      e.profilePicUrl
                        ? getMediaBasePath(e.profilePicUrl, 'userDataBucket')
                        : firstLetterImage(e.name || 'Geneo')
                    }
                    // submission={true}
                    isadded={
                      selectedStudentList.find(
                        (val) => val.studentId === e.studentId
                      ) !== undefined
                    }
                    // hideRollNo={useAttendanceApi}
                    checkBoxClickHandler={(value: boolean) => {
                      if (value === true) {
                        addSectionStudent(
                          new SectionStudent({
                            sectionId: e.sectionId,
                            studentId: e.studentId,
                          })
                        );
                      } else {
                        removeSectionStudent(
                          new SectionStudent({
                            sectionId: e.sectionId,
                            studentId: e.studentId,
                          })
                        );
                      }
                    }}
                  />
                </Box>
              </Grid>
            ))}
          </Grid>
        </Box>
        {!isMobile && (
          <ImageWrapper
            name="close-yellow"
            type="png"
            parentFolder="icons"
            onClick={onClose}
            styles={{
              height: { xs: pxToRem(50), md: pxTovW(50) },
              width: { xs: pxToRem(50), md: pxTovW(50) },
              position: { md: 'absolute' },
              top: pxTovW(20),
              right: pxTovW(-60),
              cursor: 'pointer',
            }}
          />
        )}
      </Box>
    </Modal>
  );
};
interface IStudentProps {
  studentName: string;
  className: string;
  section: string;
  rollNo: string;
  checkBoxClickHandler: (e: boolean) => void;
  isadded: boolean;
  image: string;
  hideRollNo?: boolean;
}

const StudentCard = (props: IStudentProps) => {
  const {
    studentName,
    className,
    section,
    rollNo,
    checkBoxClickHandler,
    isadded,
    image,
    hideRollNo,
  } = props;
  return (
    <Box
      onClick={() => checkBoxClickHandler(!isadded)}
      sx={{
        width: '100%',
        backgroundColor: 'white',
        py: { xs: pxToRem(10), md: pxTovW(10) },
        height: { xs: pxToRem(56), md: pxToRem(45), lg: pxTovW(80) },
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
      }}
    >
      <Checkbox
        checked={isadded}
        disableRipple
        tabIndex={-1}
        icon={<RadioButtonUncheckedIcon sx={{ color: '#02FC73' }} />}
        checkedIcon={<CheckCircleIcon color="success" />}
        sx={{
          pointerEvents: 'none',
        }}
      />
      <Box
        sx={{
          display: 'flex',
          gap: { xs: pxToRem(20), md: pxTovW(19) },
          width: '100%',
        }}
      >
        <ImageWrapper
          name="student1"
          type="png"
          parentFolder="tempAssets"
          path={image}
          styles={{
            width: { xs: pxToRem(60), md: pxTovW(80) },
            height: { xs: pxToRem(56), md: pxTovW(80) },
            borderRadius: pxToRem(15),
          }}
        />
        <Box
          sx={{
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            gap: { xs: pxToRem(10), md: pxTovW(16) },
            width: { xs: '50vw', md: '95%', lg: '80%' },
            marginY: 'auto',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: { xs: pxToRem(6), md: pxTovW(10) },
            }}
          >
            <Tooltip
              title={studentName}
              placement="bottom-start"
              disableHoverListener={!toolTipDisplay(studentName)}
              disableFocusListener={!toolTipDisplay(studentName)}
            >
              <Typography
                variant="h3"
                fontWeight="medium"
                sx={{
                  display: '-webkit-box',
                  WebkitLineClamp: 2,
                  WebkitBoxOrient: 'vertical',
                  overflow: 'hidden',
                  width: { lg: pxTovW(150) },
                }}
              >
                {studentName}
              </Typography>
            </Tooltip>
            {!hideRollNo && (
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <Typography variant="smallText" color="primary">
                  {className}
                  {section}
                </Typography>
                {!!rollNo && (
                  <>
                    <Divider
                      orientation="vertical"
                      color="#707070"
                      sx={{
                        borderColor: '1px solid red',
                        width: '0.5px',
                        height: pxTovW(20),
                        marginX: { xs: pxToRem(5), md: pxTovW(10) },
                        borderStyle: 'solid',
                      }}
                    />
                    <Typography variant="smallText" color="primary">
                      {`Roll No: ${rollNo}`}
                    </Typography>
                  </>
                )}
              </Box>
            )}
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

const toolTipDisplay = (name: string) => {
  if (name.includes(' ')) {
    if (name.length > 20) return true;
    else return false;
  } else {
    if (name.length > 10) return true;
    else return false;
  }
};

interface IAttendanceRosterFetcherProps {
  enabled: boolean;
  assessmentId?: bigint;
  fetchAttendanceList: () => Promise<void>;
}

const AttendanceRosterFetcher = (props: IAttendanceRosterFetcherProps) => {
  const { enabled, assessmentId, fetchAttendanceList } = props;

  useEffect(() => {
    if (!enabled || !assessmentId) return;
    fetchAttendanceList();
  }, [enabled, assessmentId, fetchAttendanceList]);

  return null;
};
